import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.705 21.959C5.416 23.247.871 23.125.871 23.125s-.122-4.545 1.167-5.833a3.3 3.3 0 0 1 4.667 4.667"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m7.766 18.352-2.122-2.121 3.713-6.894 10.991-8.124a1.74 1.74 0 0 1 2.267.169h0a1.74 1.74 0 0 1 .169 2.267L14.66 14.64z"
    }, null, -1)
  ]));
}
const interfaceEditToolPen = { render };
export {
  interfaceEditToolPen as default,
  render
};
//# sourceMappingURL=interface-edit-tool-pen.svg.js.map
